import { apiClient } from './axios';

import type {
  ConnectorTestResult,
  CreateDataConnectorDto,
  DataConnectorConfig,
  DataConnectorDetail,
  DataConnectorRun,
  UpdateDataConnectorDto,
} from '@repo/shared-types';

const BASE = '/crm-integration/connectors';

export const dataConnectorsApi = {
  list: async () => (await apiClient.get<DataConnectorDetail[]>(BASE)).data,

  get: async (id: string) => (await apiClient.get<DataConnectorDetail>(`${BASE}/${id}`)).data,

  create: async (data: CreateDataConnectorDto) =>
    (await apiClient.post<DataConnectorDetail>(BASE, data)).data,

  update: async (id: string, data: UpdateDataConnectorDto) =>
    (await apiClient.patch<DataConnectorDetail>(`${BASE}/${id}`, data)).data,

  remove: async (id: string, deleteListings: boolean) =>
    (await apiClient.delete<{ deleted: true }>(`${BASE}/${id}`, { params: { deleteListings } }))
      .data,

  test: async (body: {
    config: DataConnectorConfig;
    secrets?: Record<string, string>;
    connector_id?: string;
  }) => (await apiClient.post<ConnectorTestResult>(`${BASE}/test`, body)).data,

  run: async (id: string) => (await apiClient.post<{ run_id: string }>(`${BASE}/${id}/run`)).data,

  runs: async (id: string, limit = 20) =>
    (await apiClient.get<DataConnectorRun[]>(`${BASE}/${id}/runs`, { params: { limit } })).data,

  /** Answer "N cars are no longer listed — mark them unavailable?" for the latest run. */
  decide: async (id: string, runId: string, approve: boolean) =>
    (
      await apiClient.post<{ status: string; marked_unavailable: number }>(
        `${BASE}/${id}/runs/${runId}/decision`,
        { approve },
      )
    ).data,

  resume: async (id: string, runId: string) =>
    (await apiClient.post<{ run_id: string }>(`${BASE}/${id}/runs/${runId}/resume`)).data,
};
